
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire130b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire130b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8hQp0", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $60888f442cbb2719$export$6503ec6e8aabbaf; }, function (v) { return $60888f442cbb2719$export$6503ec6e8aabbaf = v; });
var $60888f442cbb2719$export$6503ec6e8aabbaf;
var $60888f442cbb2719$export$f7ad0328861e2f03;
"use strict";
var $60888f442cbb2719$var$mapping = new Map();
function $60888f442cbb2719$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$60888f442cbb2719$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $60888f442cbb2719$var$resolve(id) {
    var resolved = $60888f442cbb2719$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$60888f442cbb2719$export$6503ec6e8aabbaf = $60888f442cbb2719$var$register;
$60888f442cbb2719$export$f7ad0328861e2f03 = $60888f442cbb2719$var$resolve;

});

var $3d14e092ba69b15f$exports = {};

(parcelRequire("8hQp0")).register(new URL("", import.meta.url).toString(), JSON.parse('["ktsb4","index.0457741a.js","lxUGS","selfoss-sw-offline.js"]'));


//# sourceMappingURL=index.runtime.a9feaff5.js.map
